<template>
	<div class="tabBlock" :class="{ 'disabled': isDisabled }">
		<div>
			<v-tabs
					v-if="onlyControlTabs"
					:class="['tabList', customClass]"
					@change="onChange"
				  :value="tab"
				  :height="height"
				  center-active
			>
				<v-tabs-slider></v-tabs-slider>
				<v-tab
						v-for="item in tabList"
						:disabled="false"
						:key="item[tabText]"
						class="tab"
						:class="{'errorTab': item.error, 'active': item.active}"
				>
					{{ item[tabText] }}
				</v-tab>
			</v-tabs>
			<v-tabs-items :value="tab">
				<slot></slot>
			</v-tabs-items>
		</div>
	</div>
</template>

<script>
export default {
	name: "TabBlock",
	props: {
		height: {
			type: [ Number, String ],
			default: () => '48'
		},
		tab: Number,
		customClass: String,
		isDisabled: Boolean,
		tabList: Array,
		tabText: {
			type: String,
			default: () => 'text'
		},
		onlyControlTabs: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		onChange(value) {
			this.$emit('updateTab', value);
		}
	}
};
</script>

<style scoped lang="scss">
.tabBlock {
	.tab {

		&.errorTab {
			color: var(--base-red) !important;
			&:before {
				background-color: var(--base-red);
			}
		}
    &.active {
	    &:before {
		    color:  var(--base-green) !important;
		    opacity: 0.4 !important;
	    }
    }
	}

	.tabList {
		margin: 16px 0;
		box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
		border-radius: 4px;
	}
}
</style>
